<template>
  <div class="warehouseQuery">
    <div class="searchTop">
      <van-row type="flex" align="center" class="search-top-row">
        <van-col class="colItem1">
          <van-search
            v-model="searchText"
            show-action
            shape="round"
            background="transparent"
            :placeholder="getPlaceHolder()"
          >
            <template #action>
              <div @click="onSearch">{{ $t.meta.search }}</div>
            </template>
          </van-search>
        </van-col>
        <van-col class="colItem2">
          <div :class="isFilter() ? 'isFilter' : ''">
            <span @click="showFilter = true">{{ $t.meta.filter }}</span>
          </div>
        </van-col>
      </van-row>
    </div>

    <van-list
      class="list"
      v-model="loading"
      :finished="finished"
      :finished-text="$t.meta.noMore"
      :error.sync="error"
      :error-text="errorText"
      @load="getList"
    >
      <div class="list-container" v-for="(item, index) in tableData" :key="index">
        <div class="checkBox">
          <van-checkbox v-model="item.IsChecked" @change="handleCheckBox"></van-checkbox>
        </div>
        <div class="container">
          <div class="left">
            <div class="list-item">
              {{ $t.warehouse.productsNameSn }}：{{ item.ProductName }}
            </div>
            <div class="list-item">{{ $t.warehouse.productModel }}：{{ item.Model }}</div>
            <div class="list-item">{{ $t.warehouse.productBrand }}：{{ item.Brand }}</div>
            <div class="list-item">
              {{ $t.warehouse.numberBoxes }}：{{ item.CaseNumber }}
            </div>
            <div class="list-item">
              {{ $t.warehouse.totalPackingQuantity }}：{{ item.PackingQuantity }}
            </div>
            <div class="list-item">
              {{ $t.warehouse.unitPrice }}：{{ item.UnitPrice }}
            </div>
            <div class="list-item">
              {{ $t.warehouse.totalGoodValue }}：{{ item.TotalValue }}
            </div>
            <div class="list-item">{{ $t.meta.country }}：{{ item.CountryName }}</div>
            <div class="list-item">{{ $t.meta.city }}：{{ item.CityName }}</div>
            <div class="list-item">
              {{ $t.warehouse.warehouseCode }}：{{ item.WarehouseCode }}
            </div>
            <div class="list-item">
              {{ $t.warehouse.warehouseName }}：{{ item.WarehouseName }}
            </div>
            <div class="list-item">
              {{ $t.warehouse.entrustingParty }}：{{ item.EntrustingPartyCompanyName }}
            </div>
          </div>
          <div class="right">
            <div class="images">
              <van-image
                width="88"
                height="88"
                fit="cover"
                @click="imagePreview(item.ProductPictures)"
                :src="imgUrlFilter(item.ProductPictures)"
                v-if="item.ProductPictures"
              />
              <span v-else>{{ $t.meta.noImage }}</span>
            </div>
          </div>
        </div>
      </div>
    </van-list>

    <van-popup
      v-model="showFilter"
      position="bottom"
      :style="{ height: '80%', width: '100%' }"
    >
      <div class="popup-header">{{ $t.meta.allFilter }}</div>
      <van-form>
        <div class="radio-label">{{ $t.meta.searchType }}</div>
        <van-radio-group v-model="searchType" direction="horizontal">
          <van-radio
            :name="item.value"
            v-for="(item, index) in searchTypeOptions"
            :key="index"
            >{{ item.text }}</van-radio
          >
        </van-radio-group>

        <div class="radio-label">{{ $t.warehouse.stockQueryType }}</div>
        <van-radio-group v-model="stockQueryType" direction="horizontal">
          <van-radio :name="0">{{ $t.warehouse.stockQueryType1 }}</van-radio>
          <van-radio :name="1">{{ $t.warehouse.stockQueryType2 }}</van-radio>
        </van-radio-group>

        <van-field
          clickable
          readonly
          :value="country.text"
          :label="$t.meta.country"
          :placeholder="$t.meta.select"
          @click="onShowEmit('showWarehouseQueryCountries')"
        />

        <van-field
          clickable
          readonly
          :value="city.text"
          :label="$t.meta.city"
          :placeholder="$t.meta.select"
          @click="onShowEmit('showWarehouseQueryCities')"
        />

        <div class="custom-date">
          <div class="date-label">{{ $t.meta.date }}</div>
          <van-button class="date-btn1" type="info" size="small" @click="showStartDate">{{
            $t.meta.beginDate
          }}</van-button>
          <van-button class="date-btn2" type="info" size="small" @click="showEndDate">{{
            $t.meta.endDate
          }}</van-button>
          <div class="date-txt" v-if="beginTime || endTime">
            {{ beginTime }} {{ $t.meta.to }} {{ endTime }}
          </div>
        </div>
      </van-form>
      <div class="popup-footer">
        <van-button class="reset" type="info" block square @click="filterReset">{{
          $t.meta.reset
        }}</van-button>

        <van-button class="confirm" type="primary" block square @click="filterSubmit">{{
          $t.meta.confirm
        }}</van-button>
      </div>
    </van-popup>

    <div class="tool-bar">
      <div class="tool-bar-wrapper" v-if="showStatistics">
        <van-button block @click="showStatistics = false">{{
          $t.meta.hideStatistics
        }}</van-button>

        <div class="tool-bar-total" v-if="checkedList && checkedList.length > 0">
          <div class="tool-bar-total-left">{{ $t.meta.selectTotal }}</div>
          <div
            class="tool-bar-total-item"
            v-for="(item, index) in checkedList"
            :key="index"
          >
            <div :class="language == 'zh' ? 'item1' : 'item1-en'">{{ item.name }}</div>
            <div :class="language == 'zh' ? 'item2' : 'item2-en'">
              {{ item.value.toFixed(2) }}
            </div>
          </div>
        </div>
      </div>
      <div class="tool-bar-wrapper" v-else>
        <van-button
          type="info"
          class="statistics-button"
          block
          @click="showStatistics = true"
          >{{ $t.meta.showStatistics }}</van-button
        >

        <van-button class="more-button" @click="handleMoreSheetShow">{{
          $t.meta.more
        }}</van-button>
      </div>
    </div>

    <option-list
      event="showWarehouseQueryCountries"
      :options="countryList"
      @onSelect="onSelectCountry"
    ></option-list>

    <option-list
      event="showWarehouseQueryCities"
      :options="cityList"
      @onSelect="onSelectCity"
    ></option-list>

    <van-action-sheet
      v-model="moreSheetShow"
      :actions="moreSheetActions"
      @select="moreSheetSelect"
    />

    <van-popup v-model="showStartPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.beginDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'start')"
        @cancel="showStartPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-popup v-model="showEndPicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.meta.endDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'end')"
        @cancel="showEndPicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-dialog
      :title="$t.warehouse.emailSetting"
      width="90%"
      v-model="dialogVisible"
      @confirm="dialogConfirm"
      @cancel="dialogClose"
      :confirm-button-text="$t.meta.save"
      :cancel-button-text="$t.meta.close"
      :show-cancel-button="true"
      :show-confirm-button="true"
    >
      <slot name="default">
        <div class="warehouseQuery-alert">
          <van-field
            v-model="dialogForm.Emails"
            :label="$t.warehouse.emailLabel"
            :placeholder="$t.meta.input"
            required
            type="textarea"
          />

          <div class="warehouseQuery-radio">
            <div class="radio-label">{{ $t.warehouse.sendSetting }}</div>
            <van-radio-group v-model="dialogForm.SendSetting" direction="horizontal">
              <van-radio :name="1">{{ $t.warehouse.daily }}</van-radio>
              <van-radio :name="2">{{ $t.warehouse.fixedDate }}</van-radio>
              <van-radio :name="3">{{ $t.warehouse.weekly }}</van-radio>
              <van-radio :name="4">{{ $t.warehouse.monthly }}</van-radio>
            </van-radio-group>
          </div>

          <van-field
            clickable
            readonly
            :value="dialogForm.SendDate"
            :label="$t.warehouse.sendDate"
            :placeholder="$t.meta.select"
            @click="showDialogDate"
            v-if="dialogForm.SendSetting == 2"
          />

          <van-field
            clickable
            readonly
            :value="dialogForm.WeekStr"
            :label="$t.warehouse.weekly"
            :placeholder="$t.meta.select"
            @click="showWeekPicker = true"
            v-if="dialogForm.SendSetting == 3"
          />

          <van-field
            clickable
            readonly
            :value="dialogForm.DayStr"
            :label="$t.warehouse.monthly"
            :placeholder="$t.meta.select"
            @click="showDayPicker = true"
            v-if="dialogForm.SendSetting == 4"
          />

          <div class="warehouseQuery-radio">
            <div class="radio-label">{{ $t.warehouse.configState }}</div>
            <van-radio-group v-model="dialogForm.ConfigState" direction="horizontal">
              <van-radio :name="1">{{ $t.meta.enable }}</van-radio>
              <van-radio :name="0">{{ $t.meta.disable }}</van-radio>
            </van-radio-group>
          </div>

          <div class="warehouseQuery-radio">
            <div class="radio-label">{{ $t.warehouse.emailLanguage }}</div>
            <van-radio-group v-model="dialogForm.LanguageType" direction="horizontal">
              <van-radio :name="1">{{ $t.warehouse.emailLanguage1 }}</van-radio>
              <van-radio :name="2">{{ $t.warehouse.emailLanguage2 }}</van-radio>
            </van-radio-group>
          </div>
        </div>
      </slot>
    </van-dialog>

    <van-popup v-model="showDialogDatePicker" position="bottom">
      <van-datetime-picker
        type="date"
        :title="$t.warehouse.sendDate"
        :formatter="formatter"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dateChange($event, 'dialog')"
        @cancel="showDialogDatePicker = false"
        :min-date="currentDate"
        v-model="selectDate"
      />
    </van-popup>

    <van-popup v-model="showWeekPicker" round position="bottom">
      <van-picker
        :title="$t.warehouse.weekly"
        show-toolbar
        :columns="weekOptions"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="weekConfirm"
        @cancel="showWeekPicker = false"
      />
    </van-popup>

    <van-popup v-model="showDayPicker" round position="bottom">
      <van-picker
        :title="$t.warehouse.monthly"
        show-toolbar
        :columns="dayOptions"
        :confirm-button-text="$t.meta.confirm"
        :cancel-button-text="$t.meta.cancel"
        @confirm="dayConfirm"
        @cancel="showDayPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import OptionList from "@components/optionList/OptionList.vue";
import {
  List,
  Tab,
  Tabs,
  Row,
  Col,
  Search,
  Button,
  Form,
  Field,
  Popup,
  Picker,
  Radio,
  RadioGroup,
  Checkbox,
  Image,
  DatetimePicker,
  ActionSheet,
} from "vant";

import Vue from "vue";
Vue.use(List)
  .use(Tab)
  .use(Tabs)
  .use(Row)
  .use(Col)
  .use(Search)
  .use(Button)
  .use(Form)
  .use(Field)
  .use(Popup)
  .use(Picker)
  .use(Radio)
  .use(RadioGroup)
  .use(Checkbox)
  .use(Image)
  .use(DatetimePicker)
  .use(ActionSheet);

export default {
  name: "warehouseQuery",
  components: {
    OptionList,
  },
  data() {
    return {
      CustomerId: JSON.parse(localStorage.getItem("auth")).userInfo.CustomerId,
      language: localStorage.getItem("requestLanguage"),
      tableData: [],
      loading: false,
      finished: false,
      error: false,
      errorText: "",
      //filter
      searchText: "",
      searchType: 1,
      searchTypeOptions: [
        {
          text: this.$t.warehouse.productsNameSn,
          value: 1,
        },
        {
          text: this.$t.warehouse.productModel,
          value: 2,
        },
        {
          text: this.$t.warehouse.productBrand,
          value: 3,
        },
        {
          text: this.$t.warehouse.warehouseCode,
          value: 4,
        },
      ],
      showFilter: false,
      countryList: [],
      country: {
        text: "",
        value: "",
      },
      cityList: [],
      city: { text: "", value: "" },
      stockQueryType: 0,
      //多选
      checkedList: [],
      //日期
      selectDate: new Date(),
      currentDate: "",
      showStartPicker: false,
      beginTime: "",
      showEndPicker: false,
      endTime: "",
      //统计
      showStatistics: false,
      //更多
      moreSheetShow: false,
      moreSheetActions: [],
      //邮件配置
      dialogVisible: false,
      dialogForm: {
        SECId: null,
        Emails: "",
        SendSetting: 1,
        SendDate: "",
        SendTime: "",
        ConfigState: 1,
        LanguageType: 1,
        Week: null,
        WeekStr: "",
        Day: null,
        DayStr: "",
      },
      showDialogDatePicker: false,
      showWeekPicker: false,
      weekOptions: [
        {
          text: this.$t.warehouse.week0,
          value: 0,
        },
        {
          text: this.$t.warehouse.week1,
          value: 1,
        },
        {
          text: this.$t.warehouse.week2,
          value: 2,
        },
        {
          text: this.$t.warehouse.week3,
          value: 3,
        },
        {
          text: this.$t.warehouse.week4,
          value: 4,
        },
        {
          text: this.$t.warehouse.week5,
          value: 5,
        },
        {
          text: this.$t.warehouse.week6,
          value: 6,
        },
      ],
      showDayPicker: false,
      dayOptions: [],
    };
  },
  created() {
    this.setDayOptions();
    this.initCheckList();
    this.getOptions();
  },
  methods: {
    dayConfirm(val) {
      this.dialogForm.DayStr = val;
      this.dialogForm.Day = val;
      this.showDayPicker = false;
    },
    weekConfirm(e) {
      this.dialogForm.WeekStr = e.text;
      this.dialogForm.Week = e.value;
      this.showWeekPicker = false;
    },
    dialogConfirm() {
      var param = this.dialogForm;
      this.$commonMethod.showLoading();
      this.$api.myCustomer
        .saveStorageEmailConfig(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.dialogClose();
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    dialogClose() {
      this.dialogForm = {
        SECId: null,
        Emails: "",
        SendSetting: 1,
        SendDate: "",
        SendTime: "",
        ConfigState: 1,
        LanguageType: 1,
        Week: null,
        WeekStr: "",
        Day: null,
        DayStr: "",
      };
      this.dialogVisible = false;
    },
    moreSheetSelect(e) {
      if (e.className == "1") {
        this.getStorageEmailConfig().then((success) => {
          if (success) {
            this.dialogVisible = true;
          }
        });
      }
      if (e.className == "2") {
        this.getStorageEmailConfig().then((success) => {
          if (success) {
            if (this.dialogForm.SECId) {
              this.testStorageEmailPush();
            } else {
              this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
                msg: this.$t.warehouse.emailError,
              });
            }
          }
        });
      }
      this.moreSheetShow = false;
    },
    handleMoreSheetShow() {
      var actions = [];
      actions = [
        {
          name: this.$t.warehouse.emailSetting,
          className: "1",
        },
        {
          name: this.$t.warehouse.emailPushTest,
          className: "2",
        },
      ];

      this.moreSheetActions = actions;
      this.moreSheetShow = true;
    },
    getStorageEmailConfig() {
      return new Promise((resolve) => {
        var param = {};
        this.$api.myCustomer
          .getStorageEmailConfig(param)
          .then((res) => {
            this.dialogForm = res.data;
            if (!this.dialogForm.SendSetting) {
              this.dialogForm.SendSetting = 1;
            }
            if (!this.dialogForm.LanguageType) {
              this.dialogForm.LanguageType = 1;
            }
            if (this.dialogForm.SendSetting == 3) {
              var week = this.weekOptions.find((c) => c.value == this.dialogForm.Week);
              this.dialogForm.WeekStr = week.text;
            }
            if (this.dialogForm.SendSetting == 4) {
              this.dialogForm.DayStr = this.dialogForm.Day;
            }
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    testStorageEmailPush() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        var param = {
          SECId: this.dialogForm.SECId,
        };
        this.$api.myCustomer
          .testStorageEmailPush(param)
          .then((res) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
              titleMsg: res.message,
              type: "success",
            });
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    initCheckList() {
      this.checkedList = [
        {
          id: 1,
          name: this.$t.warehouse.queryTotal1,
          value: 0,
        },
        {
          id: 2,
          name: this.$t.warehouse.queryTotal2,
          value: 0,
        },
        {
          id: 3,
          name: this.$t.warehouse.queryTotal3,
          value: 0,
        },
      ];
    },
    handleCheckBox() {
      var list = [];
      var items = this.tableData.filter((p) => p.IsChecked);
      if (items.length > 0) {
        var C1 = {
          id: 1,
          name: this.$t.warehouse.queryTotal1,
          value: 0,
        };
        var C2 = {
          id: 2,
          name: this.$t.warehouse.queryTotal2,
          value: 0,
        };
        var C3 = {
          id: 3,
          name: this.$t.warehouse.queryTotal3,
          value: 0,
        };
        for (var item of items) {
          if (item.CaseNumber) {
            C1.value = C1.value + parseFloat(item.CaseNumber);
          }
          if (item.PackingQuantity) {
            C2.value = C2.value + parseFloat(item.PackingQuantity);
          }
          if (item.TotalValue) {
            C3.value = C3.value + parseFloat(item.TotalValue);
          }
        }
        list.push(C1);
        list.push(C2);
        list.push(C3);
        this.checkedList = list;
      } else {
        this.initCheckList();
      }
    },
    imgUrlFilter(value) {
      return this.$api.formatImageUrl(value);
    },
    imagePreview(image) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.picturePreview, {
        pictureList: [this.imgUrlFilter(image)],
        startPosition: 0,
      });
    },
    getPlaceHolder() {
      var search = this.searchTypeOptions.find((c) => c.value == this.searchType);
      if (search) {
        return search.text;
      } else {
        return this.$t.meta.searchText;
      }
    },
    onSearch() {
      this.initList();
      this.getList();
    },
    isFilter() {
      if (this.country.value || this.city.value || this.stockQueryType) {
        return true;
      } else {
        return false;
      }
    },
    filterReset() {
      this.searchText = "";
      this.searchType = 1;
      this.country = { text: "", value: null };
      this.city = { text: "", value: null };
      this.stockQueryType = 0;
      this.beginTime = "";
      this.endTime = "";
      this.initList();
      this.getList();
    },
    filterSubmit() {
      this.initList();
      this.getList();
    },
    initList() {
      this.loading = true;
      this.finished = false;
      this.error = false;
      this.showFilter = false;
      this.tableData = [];
      this.initCheckList();
    },
    getOptions() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        Promise.all([this.getCountryList(), this.getCityList()]).then((success) => {
          if (success) {
            resolve(true);
          }
          this.$commonMethod.hideLoading();
        });
      });
    },
    getCountryList() {
      var param = {};
      return new Promise((resolve) => {
        this.$api.customerManagement
          .getCountryList(param)
          .then((res) => {
            this.formatCountry(res.data);
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    formatCountry(countrys) {
      countrys.forEach((item) => {
        let country = {
          text: item.CountryName,
          value: item.CountryId,
        };
        this.countryList.push(country);
      });
    },
    getCityList() {
      var param = {};
      return new Promise((resolve) => {
        this.$api.logisticsManagement
          .getCountryList(param)
          .then((res) => {
            this.formatCity(res.data);
            resolve(true);
          })
          .catch((error) => {
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    formatCity(cities) {
      cities.forEach((item) => {
        let city = {
          text: item.City_cn,
          value: item.Id,
        };
        this.cityList.push(city);
      });
    },
    onSelectCountry(e) {
      this.country.text = e.text;
      this.country.value = e.value;
      this.$forceUpdate();
    },
    onSelectCity(e) {
      this.city.text = e.text;
      this.city.value = e.value;
      this.$forceUpdate();
    },
    onShowEmit(emit) {
      this.$bus.$emit(emit, true);
    },
    getList() {
      var param = {
        CustomerId: this.CustomerId,
        ProductName: this.searchType == 1 ? this.searchText : "",
        Model: this.searchType == 2 ? this.searchText : "",
        Brand: this.searchType == 3 ? this.searchText : "",
        WarehouseCodeOrName: this.searchType == 4 ? this.searchText : "",
        CountryId: this.country.value,
        CityId: this.city.value,
        OrderState: this.stockQueryType,
        BeginTime: this.beginTime,
        EndTime: this.endTime,
      };
      this.$api.myCustomer
        .cargoStorageInquiry(param)
        .then((res) => {
          this.tableData = res.data;
          this.initCheckList();
          this.loading = false;
          this.error = false;
          this.errorText = "";

          this.finished = true;
        })
        .catch((error) => {
          this.loading = false;
          this.error = true;
          this.errorText = error.message;
        });
    },
    showStartDate() {
      var start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = start;
      this.showStartPicker = true;
    },
    showEndDate() {
      var end = new Date();
      end.setTime(end.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = end;
      this.showEndPicker = true;
    },
    showDialogDate() {
      var date = new Date();
      date.setTime(date.getTime() - 3600 * 1000 * 24 * 36500);
      this.currentDate = date;
      this.showDialogDatePicker = true;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + this.$t.meta.year;
      }
      if (type === "month") {
        return val + this.$t.meta.month;
      }
      if (type === "day") {
        return val + this.$t.meta.day;
      }
      return val;
    },
    dateChange(date, type) {
      var formatDate = (val) => {
        var time = new Date(val).toLocaleDateString();
        let [year, month, date] = time.split("/");
        if (month < 10) {
          month = "0" + month;
        }
        if (date < 10) {
          date = "0" + date;
        }
        return year + "-" + month + "-" + date;
      };
      if (type == "start") {
        this.beginTime = formatDate(date);
        this.showStartPicker = false;
      }
      if (type == "end") {
        this.endTime = formatDate(date);
        this.showEndPicker = false;
      }
      if (type == "dialog") {
        this.dialogForm.SendDate = formatDate(date);
        this.showDialogDatePicker = false;
      }
    },
    setDayOptions() {
      var dayOptions = [];
      for (var i = 1; i <= 31; i++) {
        dayOptions.push(i.toString());
      }
      this.dayOptions = dayOptions;
    },
  },
};
</script>
<style lang="scss" scoped>
@import "~assets/scss/var";

.warehouseQuery {
  .searchTop {
    width: 100%;
    background-color: #ffffff;
    border-bottom: 1px solid #ebedf0;

    .search-top-row {
      width: 100%;
      text-align: center;
      background-color: transparent;

      .colItem1 {
        width: 80%;
        text-align: center;
        font-size: 14px;

        .van-search__content {
          padding: 0px;
          margin-right: 10px;

          .van-cell {
            padding: 5px 8px 5px 8px;
          }
        }
      }

      .colItem2 {
        width: 20%;
        text-align: center;
        font-size: 14px;

        .isFilter {
          color: $-color-primary;
          font-weight: bold;
        }
      }
    }
  }

  .list {
    .list-container {
      font-size: 12px;
      color: #333;

      .checkBox {
        vertical-align: middle;
        display: inline-block;
        margin: 15px;
      }

      .container {
        box-shadow: 0px 1px 5px 1px rgba(0, 0, 0, 0.2);
        padding: 10px;

        .left {
          vertical-align: middle;
          display: inline-block;
          width: 60%;

          .list-item {
            margin-bottom: 10px;
          }

          .list-item:last-child {
            margin-bottom: 0px;
          }
        }

        .right {
          vertical-align: middle;
          display: inline-block;
          width: 40%;

          .images {
            overflow: hidden;
            vertical-align: middle;
            text-align: center;

            ::v-deep img {
              border-radius: 8px;
            }
          }
        }
      }
    }
  }

  .popup-header {
    margin-top: 20px;
    margin-bottom: 10px;
    padding-bottom: 10px;
    text-align: center;
    font-size: 16px;
  }

  .van-form {
    width: 90%;
    margin: auto;
    padding-bottom: 20vw;

    .van-cell:after {
      border: none;
    }

    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }

    .radio-label {
      color: #646566;
      margin-bottom: 10px;
      font-size: 14px;
    }

    .van-radio-group {
      margin-bottom: 20px;
    }

    .van-radio {
      margin-bottom: 10px;
      font-size: 14px;

      ::v-deep .van-radio__label {
        color: #646566;
      }
    }

    .custom-date {
      text-align: center;
      border-bottom: 1px solid #ebedf0;
      padding-bottom: 20px;

      .date-label {
        text-align: left;
        font-size: 14px;
        color: #646566;
        margin-left: 15px;
        margin-bottom: 10px;
        margin-top: 10px;
      }

      .date-btn1 {
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;

        .van-button__text {
          font-size: 14px !important;
        }
      }

      .date-btn2 {
        margin-left: 30px;
        border-radius: 5px;
        color: white;
        border: none;
        vertical-align: middle;

        .van-button__text {
          font-size: 14px !important;
        }
      }

      .date-txt {
        margin-top: 20px;
        font-size: 14px;
        color: #999;
        border-radius: 10px;
      }
    }
  }

  .popup-footer {
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 100;
    background-color: white;
    padding-bottom: env(safe-area-inset-bottom);
    width: 100%;

    .reset {
      width: 50%;
      display: inline-block;
      color: $-color-primary;
      background: #ffffff;
      border: none;
    }

    .confirm {
      width: 50%;
      display: inline-block;
      color: #ffffff;
      background: $-color-primary;
      border: none;
    }
  }

  .tool-bar-total {
    font-size: 12px;
    color: #333333;
    background: #fff;

    .tool-bar-total-left {
      display: inline-block;
      width: 25%;
      text-align: center;
      vertical-align: middle;
    }

    .tool-bar-total-item {
      display: inline-block;
      width: 25%;
      text-align: center;
      vertical-align: middle;

      .item1 {
        padding: 5px;
        background: #1e90ff;
        color: #ffffff;
      }

      .item2 {
        padding: 5px;
        background: #e8f4ff;
      }

      .item1-en {
        min-height: 50px;
        padding: 5px;
        background: #1e90ff;
        color: #ffffff;
      }

      .item2-en {
        padding: 5px;
        background: #e8f4ff;
      }
    }
  }

  .warehouseQuery-alert {
    overflow: scroll;
    height: 100vw;
    margin-top: 30px;
    margin-bottom: 30px;
    border-top: 1px solid #ebedf0;
    position: relative;

    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }

    .van-cell::after {
      border: none !important;
    }

    .warehouseQuery-radio {
      padding: 15px 15px 0px 15px;
      border-bottom: 1px solid #ebedf0;

      .radio-label {
        color: #646566;
        margin-bottom: 15px;
        font-size: 14px;
      }

      .van-radio {
        margin-right: 20px;
        margin-bottom: 15px;
        font-size: 14px;
      }
    }
  }

  .tool-bar {
    box-sizing: border-box;
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background-color: white;
    z-index: 100;
    justify-content: space-between;
    padding-bottom: env(safe-area-inset-bottom);

    .statistics-button {
      border: none;
      border-radius: 0px;
      display: inline-block;
      width: 70%;
    }

    .more-button {
      background: #5029c3;
      color: #fff;
      border: none;
      border-radius: 0px;
      display: inline-block;
      width: 30%;
    }
  }
}
</style>
